<div  class="full-width" fxLayoutAlign="end center">
  <mat-form-field fxFill fxFlex.gt-md="40" appearance="outline">
    <input matInput [formControl]="searchControl">
    <mat-label>Buscar empresa</mat-label>
  </mat-form-field>
</div>

<div fxLayout="column" fxLayoutAlign="start start" fxLayoutGap="15px">
  <table mat-table [dataSource]="items" class="mat-elevation-z1 responsive-table-desktop" style="width: 100%;">
    <ng-container matColumnDef="id">
      <th mat-header-cell *matHeaderCellDef>ID</th>
      <td mat-cell *matCellDef="let business"> {{business.id}} </td>
    </ng-container>

    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef>Empresa</th>
      <td mat-cell *matCellDef="let business"> {{business.name}} ({{business.fantasy_name}}) </td>
    </ng-container>

    <ng-container matColumnDef="cnpj">
      <th mat-header-cell *matHeaderCellDef>CNPJ</th>
      <td mat-cell *matCellDef="let business"> {{business?.cnpj | mask:'CPF_CNPJ'}} </td>
    </ng-container>
    <ng-container matColumnDef="users">
      <th mat-header-cell *matHeaderCellDef><strong>Usuários</strong></th>
      <td mat-cell *matCellDef="let business">
        <button
          mat-icon-button
          color="primary"
          (click)="listBusinessUsers(business.id)"
        >
          <mat-icon>supervisor_account</mat-icon>
        </button>
      </td>
    </ng-container>

    <ng-container matColumnDef="calls">
      <th mat-header-cell *matHeaderCellDef><strong>Chamados</strong></th>
      <td mat-cell *matCellDef="let business">
        <button
          mat-icon-button
          color="primary"
          (click)="listBusinessCalls(business.id)"
        >
          <mat-icon>list</mat-icon>
        </button>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>
  <app-list-business-responsive
    class="responsive-table-mobile"
    [items]="items"
  ></app-list-business-responsive>
  <mat-paginator
    fxFill
    class="responsive-paginator"
    [length]="length"
    [pageSize]="pageSize"
    [pageSizeOptions]="pageSizeOptions"
    (page)="setPage = $event"
  >
  </mat-paginator>
</div>
